import type { IconNode } from '../types';

/**
 * @name kettle
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgNnYxIiAvPgogIDxwYXRoIGQ9Ik0yIDIyaDE2IiAvPgogIDxwYXRoIGQ9Ik0zIDE4Yy0uNiAwLTEtLjQtMS0xdi0yYTggOCAwIDAgMSAxNiAwdjJjMCAuNi0uNCAxLTEgMVoiIC8+CiAgPHBhdGggZD0iTTUgOC44VjdhNSA1IDAgMCAxIDEwIDB2MS44IiAvPgogIDxwYXRoIGQ9Ik0xOCAxNC41QTkuMDYgOS4wNiAwIDAgMCAyMiA3bC0zLTFjLTEgMi0zLjUgNS05IDUtMi41IDAtNC40LS42LTUuOC0xLjUiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/kettle
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const kettle: IconNode = [
  ['path', { d: 'M10 6v1', key: '1vrtk3' }],
  ['path', { d: 'M2 22h16', key: '1wudgv' }],
  ['path', { d: 'M3 18c-.6 0-1-.4-1-1v-2a8 8 0 0 1 16 0v2c0 .6-.4 1-1 1Z', key: 'fgsrao' }],
  ['path', { d: 'M5 8.8V7a5 5 0 0 1 10 0v1.8', key: '7y6pzx' }],
  [
    'path',
    { d: 'M18 14.5A9.06 9.06 0 0 0 22 7l-3-1c-1 2-3.5 5-9 5-2.5 0-4.4-.6-5.8-1.5', key: '45xty7' },
  ],
];

export default kettle;
